/**
 * Copyright (C) 2019 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */

// Checking all browser implementations of full screen element to see if full screen mode is off
export const isFullScreenModeOff = () => {
  return (
    !document['fullscreenElement'] &&
    !document['mozFullScreenElement'] &&
    !document['webkitFullscreenElement'] &&
    !document['msFullscreenElement']
  );
};

// Request the provided div to enter full screen mode
export const requestFullscreenMode = (divToFullScreen: HTMLElement) => {
  if (divToFullScreen.requestFullscreen) {
    divToFullScreen.requestFullscreen();
    // @ts-ignore
  } else if (divToFullScreen.msRequestFullscreen) {
    // @ts-ignore
    divToFullScreen.msRequestFullscreen(); // IE
    // @ts-ignore
  } else if (divToFullScreen.mozRequestFullScreen) {
    // @ts-ignore
    divToFullScreen.mozRequestFullScreen(); // Firefox
    // @ts-ignore
  } else if (divToFullScreen.webkitRequestFullscreen) {
    // @ts-ignore
    divToFullScreen.webkitRequestFullscreen(); // Safari
  }
};

// Requests the provided div to exit full screen mode
export const requestExitFullscreenMode = () => {
  // @ts-ignore
  if (document.exitFullscreen) {
    // @ts-ignore
    document.exitFullscreen();
    // @ts-ignore
  } else if (document.msExitFullscreen) {
    // @ts-ignore
    document.msExitFullscreen(); // IE
    // @ts-ignore
  } else if (document.mozCancelFullScreen) {
    // @ts-ignore
    document.mozCancelFullScreen(); // Firefox
    // @ts-ignore
  } else if (document.webkitExitFullscreen) {
    // @ts-ignore
    document.webkitExitFullscreen(); // Safari
  }
};

// Register the on full screen change event to the provided html element
export const registerOnFullscreenChange = (divToRegister: HTMLElement, fullScreenHandler: any) => {
  if ('onfullscreenchange' in document) {
    divToRegister.onfullscreenchange = fullScreenHandler;
  }
  if ('onmozfullscreenchange' in document) {
    // @ts-ignore
    divToRegister.onmozfullscreenchange = fullScreenHandler; // Firefox
  }
  if ('onwebkitfullscreenchange' in document) {
    // @ts-ignore
    divToRegister.onwebkitfullscreenchange = fullScreenHandler; // Safari
  }
  if ('onmsfullscreenchange' in document) {
    // @ts-ignore
    document.onmsfullscreenchange = fullScreenHandler; // IE
  }
};
